import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { RemitRemark, RemitRemarkPayload } from '@/types/billing';
import PaginatedResponse from '@/types/paginatedResponse';
import RepositoryResponse from '@/types/repositoryResponse';

import { createRepository } from './GenericRepository';

const basePath = '/api/billing/remit_remarks';

export const remitRemarkRepository = createRepository<RemitRemark, RemitRemarkPayload>(basePath);

const RemitRemarkRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(
      params: Record<string, string> = {}
    ): Promise<RepositoryResponse<PaginatedResponse<RemitRemark[]>>> {
      return remitRemarkRepository.list({ host, params });
    },

    async get({ id }: { id: string }): Promise<RepositoryResponse<RemitRemark>> {
      return remitRemarkRepository.get({ host, id });
    },
    async create({ data }: { data: RemitRemarkPayload }): Promise<RemitRemark> {
      return remitRemarkRepository.create({ host, data });
    },
    async update({ id, data }: { id: string; data: RemitRemarkPayload }): Promise<RemitRemark> {
      return remitRemarkRepository.update({ host, id: id, data });
    },
    async delete({ id }: { id: string }) {
      return await remitRemarkRepository.delete({ host, id });
    }
  };
};

export default RemitRemarkRepository;
